import React from 'react';
export interface IconProps extends React.HTMLAttributes<HTMLElement> {
  size?: number;
  color?: string;
  children: string;
}

export const Icon = ({ size = 24, color, children, ...props }: IconProps) => {
  return (
    <i
      {...props}
      className={`${'material-icons-outlined'}${props.className ? ` ${props.className}` : ''}`}
      style={{ fontSize: size, color, ...props?.style }}
    >
      {children}
    </i>
  );
};
